<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Supported Banking Formats</h1>
    <p>To ensure the file we provide works correctly with your Internet Banking, please select the file format you need.</p>
    <p>Some formats are specific to certain banks, while others are more general.</p> 
    <p>If you’re not sure which one to choose, your bank or online banking support team should be able to confirm the correct format for payroll uploads.</p>
    </div>

    <div class="cell small-5">
      <form class="fieldset" @submit.prevent> 
        <label for="bankingFormat">Banking File Format</label>
        <select
          id="bankingFormat"
          v-model="props.formData.bankingFormat"
          required
        >
          <option disabled value="">Please select a format</option>
          <option>Standard Format</option>
          <option>Apacs 18</option>
          <option>ABN Amro</option>
          <option>AIB CSV Std 2</option>
          <option>BACS Genie</option>
          <option>Bank of Scotland</option>
          <option>BACSTEL-IP RTI</option>
          <option>Barclays Business Master Format</option>
          <option>Barclays Internet Banking</option>
          <option>Clydesdale Bank EFT</option>
          <option>Coutts Crownline</option>
          <option>HOBS</option>
          <option>HSBC</option>
          <option>HSBCnet</option>
          <option>Lloyds Commercial Banking (COL BACS)</option>
          <option>Lloyds Online Commercial Banking</option>
          <option>Lloyds PayLink</option>
          <option>Metro Bank</option>
          <option>NAB</option>
          <option>NatWest BankLine</option>
          <option>NatWest BankLine (internet)</option>
          <option>Natwest Bankline (Ad-hoc)</option>
          <option>Northern Bank</option>
          <option>PT2000</option>
          <option>RoyLine</option>
          <option>Santander Connect</option>
          <option>SEB</option>
          <option>Web BACS</option>

        </select>


      </form>
    </div>
  


</template>


<script setup>

import { ref, onMounted  } from 'vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];

  if (!props.formData.bankingFormat) {
    error.value.push('Please select a banking file format.');
  }
  if (error.value.length > 0) return false;


  return true;
}




const executeStep = async () => {
  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>